import React, { useContext } from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";
import SocialMedia from "../../components/socialMedia/SocialMedia";


export default function Footer() {
  const { isDark } = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      {/* <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("")}
        </p>
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {" "}
          <a href="mailto:saktus3@gmail.com">
            saktus3@gmail.com
          </a>
        </p>
      </div> */}
      <footer style={{ marginTop:'0px', paddingTop:'0px'}} className={isDark ? "dark-mode main" : "main"}>
        
           
              <div className="col-sm-12 p-0">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d912.5362298718214!2d90.39143782919604!3d23.813445225964774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDQ4JzQ4LjQiTiA5MMKwMjMnMzEuMiJF!5e0!3m2!1sen!2sbd!4v1619952467974!5m2!1sen!2sbd" width="100%" height="300"  allowfullscreen="" loading="lazy"></iframe>
              </div>
            
          
          <div className="text-center pt-5 pb-3">
            <SocialMedia />
            <small>Copyright {new Date().getFullYear()}.<span style={{ color: '#166AB8', fontSize: '20px' }}>shakilahmed</span>5161@gmail.com All Rights Reserved. Dhaka, Bangladesh.</small>
          </div>
          {/* <div className="pt-5 pb-3 text-center">
                <small>Copyright {new Date().getFullYear()} All Rights Reserved</small>
            </div> */}
        
      </footer>
    </Fade>
  );
}
